import formatRelative from 'date-fns/formatRelative';
import isToday from 'date-fns/isToday';
import isThisMinute from 'date-fns/isThisMinute';
import isThisHour from 'date-fns/isThisHour';
import eachHourOfInterval from 'date-fns/eachHourOfInterval';
import isYesterday from 'date-fns/isYesterday';
import differenceInDays from 'date-fns/differenceInDays';
import differenceInWeeks from 'date-fns/differenceInWeeks';
import differenceInYears from 'date-fns/differenceInYears';

export const formatTime = date => {
    const [minutes, hours] = [date.getMinutes(), date.getHours()];
    const twelveHourClock = hours < 12 ? 'am' : 'pm';
    const tweleveHours = hours <= 12 ? hours : hours - 12;
    const min = minutes < 10 ? `0${minutes}` : minutes;
    return `${tweleveHours}:${min} ${twelveHourClock}`;
};

export const formatTimeFriendly = date => {
    if (isToday(date)) {
        return formatTime(date);
    }
    return formatRelative(date, new Date());
};

// not updating time yet so just use today
// xd
// xw
// xy
export const formatShortTime = date => {
    if (isToday(date)) {
        return `Today`;
    }
    if (differenceInDays(new Date(), date) <= 7) {
        return `${differenceInDays(new Date(), date)}d`;
    }
    if (differenceInDays(new Date(), date) <= 365) {
        return `${differenceInWeeks(new Date(), date)}w`;
    }
    return `${differenceInYears(new Date(), date)}y`;
};
